import { Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { Home } from './pages/Home';
import { Dashboard } from './pages/Dashboard';
import { SynopticDevices } from './pages/SynopticDevices';
import { Areas } from './pages/Areas';
import { Maps } from './pages/Maps';
import { Settings } from './pages/Settings';
import { Alarms } from './pages/Alarms';
import { Beacons } from './pages/Beacons';
import { useIsAuthenticated } from '@azure/msal-react';
//import { loginRequest } from './authConfig';

import { IntlProvider, LocalizationProvider, load, loadMessages } from '@progress/kendo-react-intl';

import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import dateFields from 'cldr-dates-full/main/en/dateFields.json';

import itNumbers from 'cldr-numbers-full/main/it/numbers.json';
import itLocalCurrency from 'cldr-numbers-full/main/it/currencies.json';
import itCaGregorian from 'cldr-dates-full/main/it/ca-gregorian.json';
import itDateFields from 'cldr-dates-full/main/it/dateFields.json';
import timeZoneNames from "cldr-dates-full/main/it/timeZoneNames.json";

import { useCallback, useEffect, useRef, useState } from 'react';

import translation_it from "./locales/it/translation_it.json"
import translation_en from "./locales/en/translation_en.json"
import { enMessages } from "./locales/en/en-US.js"
import { itMessages } from "./locales/it/it-IT.js"

import 'hammerjs';
import './App.scss';
import { AppContext } from './AppContext';
import { Synchro } from './pages/Synchro';
import { ConfigDevicesManagement } from './components/configuration/devices/ConfigDevicesManagement';
import { ConfigMaps } from './components/configuration/ConfigMaps';
import { ConfigBeacons } from './components/configuration/ConfigBeacons';
import {  ConfigRulesTimeslot } from './components/configuration/rules/ConfigRulesTimeslot';
import { ConfigPrivacy } from './components/configuration/ConfigPrivacy';
import { ConfigDevicesBinding } from './components/configuration/devices/ConfigDevicesBinding';
import { ConfigLocatorCollector } from './components/configuration/locator/ConfigLocatorCollector';
import { ConfigLocatorServer } from './components/configuration/locator/ConfigLocatorServer';
import { ConfigDevicesEnable } from './components/configuration/devices/ConfigDevicesEnable';
import { ConfigLocatorSynchro } from './components/configuration/locator/ConfigLocatorSynchro';
import { ConfigRulesSubscription } from './components/configuration/rules/ConfigRulesSubscription';
import { ConfigRulesSubscriptionAPI } from './components/configuration/rules/ConfigRulesSubscriptionAPI';
import { ConfigRulesAlarmActionHandlers } from './components/configuration/rules/ConfigRulesAlarmActionHandlers';
import { RegistryGroups } from './components/configuration/registry/RegistryGroups';
import { RegistryJobs } from './components/configuration/registry/RegistryJobs';
import { HeatMap } from './components/configuration/analysis/HeatMap';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import axios from 'axios';
import { AccessToken } from './config/AccessToken';
import { NotificationGroup, Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import { loadingPanel } from './components/LoadingPanel';
import { AzureMapComponent } from './pages/AzureMapComponent';
import { setupAxiosInterceptors } from './config/setupAxiosInterceptors ';
import { ConfigZones } from './components/configuration/maps/Zones';


load(
    likelySubtags,
    currencyData,
    weekData,
    dateFields,
    itNumbers,
    itLocalCurrency,
    itCaGregorian,
    itDateFields,
    timeZoneNames,
    itMessages
)

loadMessages(translation_it, "it-IT");
loadMessages(itMessages, 'it-IT');
loadMessages(translation_en, "en-US");
loadMessages(enMessages, 'en-US');


const App = () => {

    const navigate = useNavigate()

    const [theme, setTheme] = useState("https://unpkg.com/@progress/kendo-theme-bootstrap@latest/dist/all.css");

    //const localizationService = useLocalization();
    let languageId = localStorage.getItem('languageId');
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();

    const [loading, setLoading] = useState<any>(false);
    const [errorMessage, setErrorMessage] = useState<any>('');
    const [toggleShowErrorMessage, setToggleShowErrorMessage] = useState<boolean>(false);

    const emailNotFoundMessage:any = languageId == 'it-IT' ? 'Email non trovata' : 'Email not found';

    const changeTheme = (theme:string) => {
        setTheme(theme);
    }    
    
    let authConfig:any;

    if (process.env.NODE_ENV === "production") {
        authConfig = require("./authConfig.production");
    } 
    else { // Default to development
        authConfig = require("./authConfig.local");
    }

    //const fetchCompanyInfo = (accessToken:any) => {
    //    axios.get("https://graph.microsoft.com/v1.0/me", {
    //      headers: {
    //        Authorization: `Bearer ${accessToken}`,
    //      },
    //    })
    //      .then((res:any) => res.json())
    //      .then((data:any) => {
    //        console.log("User Info:", data);
    //        // You can also access the organization info here
    //        axios.get("https://graph.microsoft.com/v1.0/organization", {
    //          headers: {
    //            Authorization: `Bearer ${accessToken}`,
    //          },
    //        })
    //        .then((orgRes:any) => orgRes.json())
    //        .then((orgData:any) => {
    //            console.log("Organization Info:", orgData);
    //            alert(`Company Name: ${orgData.value[0].displayName}`);
    //        });
    //    }
    //)}

    

    const handleLogin = async () => {    
        
        setLoading(true)

        try {
          const response:any = await instance.loginPopup(authConfig.loginRequest);    
        //  console.log(response);    
          const userEmail:string = response.account.username
          const username:string = response.account.name
          

        //  fetchCompanyInfo(response.accessToken)

          if(userEmail == null && username == ''){
            setErrorMessage(emailNotFoundMessage)
            if(!toggleShowErrorMessage){
                setTimeout(() => {
                    setToggleShowErrorMessage(false)
                }, 10000)
            }
          }

          if(response){    

            const commonOperations = async (accessToken: any) => {
                const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
                axios.get(`${SERVER_URL}/account/${userEmail}`, { headers })
                .then((response) => {
                    let usernameType:any = response.data.data.userType;  // admin - superadmin - clientadmin - synchro
                    let email:any = response.data.data.email;  // admin - superadmin - clientadmin - synchro
                    let type:any = response.data.data.type;
                    let accountId:any = response.data.data.id;

                    localStorage.setItem('type', type)      
                    localStorage.setItem('userType', usernameType)      
                    localStorage.setItem('accountId', accountId)      
                    
                    localStorage.setItem('sso', 'true')      


                    switch (usernameType) {
                        case 'UbiquicomAdmin':
                            localStorage.setItem('userType', 'UbiquicomAdmin')
                            localStorage.setItem('user', username)
                            localStorage.setItem('email', email)            
                            if(username == 'azure'){
                                navigate('/home/azure_map')
                            }else{
                                navigate('/home/dashboard')
                            }                    
                            break;
                        case 'UbiquicomSuperAdmin':
                            localStorage.setItem('userType', 'UbiquicomSuperAdmin')
                            localStorage.setItem('user', username)
                            localStorage.setItem('email', email)
                            navigate('/home/dashboard')
                            break;
                        case 'GuestLocator':
                            localStorage.setItem('userType', 'ClientAdmin')
                            localStorage.setItem('user', username)
                            localStorage.setItem('email', email)
                            navigate('/home/dashboard')
                            break;
                        case 'GuestSynchro':
                            localStorage.setItem('userType', 'GuestSynchro')
                            localStorage.setItem('user', username)
                            localStorage.setItem('email', email)
                            navigate('/home/synchro')
                            break;
                        default:
                            localStorage.setItem('user', username)
                            localStorage.setItem('email', email)
                            navigate('/home/dashboard')
                            break;
                    }

                    setLoading(false)
                })
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    setToggleShowErrorMessage(true)
                    //setErrorMessage(userNotFoundMessage)
                    setErrorMessage(error?.response?.data?.errorMessage ?? error?.message)
                    if(!toggleShowErrorMessage){
                        setTimeout(() => {
                            setToggleShowErrorMessage(false)
                        }, 10000)
                    }
                    setLoading(false)
                });
            }
            if (localStorage.getItem('accessToken') != null || localStorage.getItem('accessToken') != null) {
                let accessToken = localStorage.getItem('accessToken') ?? localStorage.getItem('accessToken');
                commonOperations(accessToken);
            } else {
                await instance.initialize();
                await instance.setActiveAccount(response.account);
                await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
                    let accessToken = accessTokenResponse.accessToken;
                    commonOperations(accessToken);
                })
                .catch((error: any) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(accessTokenRequest);
                    }
                    //console.log(error);
                });
            }  

          }        
        } catch (error) {
            setLoading(false)    
        }
    }

    const [contextState, setContextState] = useState({
        localeId: localStorage.getItem('languageId') ?? 'it-IT',
        locale: localStorage.getItem('languageId') == 'en-US' ? 'English' : 'Italiano',
        languageId: localStorage.getItem('languageId') ?? 'it-IT'
    });
    
    const onLanguageChange:any = useCallback((event:any) => { 
        localStorage.setItem('languageId', event.value.localeId)
        setContextState({ ...contextState, localeId: event.value.localeId }) 
        },[]
    );
    
    const [showPopupInfo, setShowPopupInfo] = useState<boolean>(false);
    const [showPopupAlarm, setShowPopupAlarm] = useState<boolean>(false);

    const handlePopupInfo = () => {
        setShowPopupInfo(!showPopupInfo)    
    };
    
    const handlePopupAlarm = () => {
        setShowPopupAlarm(!showPopupAlarm)    
    };

    const childRef:any = useRef()

    const [batteryPercentage, setBatteryPercentage] = useState<any>(localStorage.getItem('batteryPercentage') ?? 10);
    const currBatteryPercentage = localStorage.getItem('batteryPercentage');
    if(currBatteryPercentage == null){
        localStorage.setItem('batteryPercentage', '30')
    }
    
    const updateBatteryPercentage = (percentage:any) => {
        setBatteryPercentage(percentage)
    }
    
    const [valueRefreshAPI, setValueRefreshAPI] = useState<any>(localStorage.getItem('valueRefreshAPI') ?? 30);
    const currValueRefreshAPI = localStorage.getItem('refreshAPI');
    if(currValueRefreshAPI == null){
        localStorage.setItem('refreshAPI', '30')
    }
    const updateValueRefreshAPI = (value:any) => {
        setValueRefreshAPI(value)
    }

    const [regularTag, setRegularTag] = useState<any>(localStorage.getItem('regularTag') ?? 5);
    const currValueRegularTag = localStorage.getItem('regularTag');
    if(currValueRegularTag == null){
        localStorage.setItem('regularTag', '5')
    }
    const updateRegularTag = (value:any) => {
        setRegularTag(value)
    }
    
    const [statusDevice, setStatusDevice] = useState<any>(localStorage.getItem('statusDevice') ?? 75);
    const currValueStatusDevice = localStorage.getItem('statusDevice');
    if(currValueStatusDevice == null){
        localStorage.setItem('statusDevice', '75')
    }
    const updateStatusDevice = (value:any) => {
        setStatusDevice(value)
    }
    
    let isAuthenticated:boolean = useIsAuthenticated();

    //if(localStorage.getItem('accessToken') != null){
    if(localStorage.getItem('accessToken') != null || localStorage.getItem('accessToken') != null){
        isAuthenticated = true
    }

    useEffect(() => {
        localStorage.setItem('languageId', contextState.localeId)
    },[])    

    //const isTokenExpired = () => {
    //    const token = localStorage.getItem('accessToken');
    //    if (!token) return true;  // If no token, consider it expired
      
    //    try {
    //      const decodedToken:any = jwtDecode(token);
    //      const currentTime = Date.now() / 1000; // Current time in seconds
    //      return decodedToken.exp < currentTime;
    //    } catch (e) {
    //      return true; // If token is invalid, treat it as expired
    //    }
    //};

    // useEffect(() => {
    //    if (isTokenExpired()) {
    //        // rimuovi token e reindirizza
    //        localStorage.removeItem("accessToken");
    //        navigate("/");
    //    }
    //}, []);

    const location = useLocation();

    useEffect(() => {
        if(location.pathname != "/home/map"){
            localStorage.removeItem('deviceMac')
            localStorage.removeItem('deviceMacFromSynoptic')
            localStorage.removeItem('onlyBoundMap')
            localStorage.removeItem('deviceMapId')
            localStorage.removeItem('alarmInfoSelected')
            localStorage.removeItem('mapSelected')
            localStorage.removeItem('beaconId')
            localStorage.removeItem('beaconFromGrid')
            localStorage.removeItem('beaconsByMapId')
            localStorage.removeItem('mapIdByBeacon')
            localStorage.removeItem('liveStatus')
            localStorage.removeItem('onlyBound')                                  
        }
    }, [location]); // Re-run effect when the 'location' object changes

    useEffect(() => {
        setupAxiosInterceptors(navigate);
    }, [navigate]);

    return (      
        <div style={{display:'inline'}} >
            {loading && loadingPanel}            
            <LocalizationProvider language={contextState.localeId}>
                <IntlProvider locale={contextState.localeId}>
                    <AppContext.Provider value={{ ...contextState, onLanguageChange, changeTheme }}> 
                        <link rel="stylesheet" href={theme}></link>
                        <NotificationGroup
                            style={{
                                right: 0,
                                bottom: 50,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse",
                            }}
                        >
                            <Fade enter={true} exit={true}>
                                {toggleShowErrorMessage && (
                                    <Notification
                                        type={{ style: "error", icon: true }}
                                        closable={true}
                                        onClose={() => setToggleShowErrorMessage(false)}
                                    >
                                        <span>{errorMessage}</span>
                                    </Notification>
                                )}                        
                            </Fade>
                        </NotificationGroup>
                        <Routes>
                        { isAuthenticated ?
                            <>
                                <Route path="/" element={<LoginPage handleLogin={handleLogin} />} />
                                <Route path="/home" element={<Home changeTheme={changeTheme} theme={theme} /> } >       
                                    <Route 
                                        path="/home/dashboard" 
                                        element={
                                            <Dashboard 
                                                //ref={childRef} 
                                                //batteryPercentage={batteryPercentage} 
                                                regularTag={regularTag} 
                                            />
                                        } 
                                    />
                                    <Route path="/home/synoptic" element={<SynopticDevices />} />
                                    <Route path="/home/beacons" element={<Beacons />} />
                                    <Route path="/home/areas" element={<Areas />} />
                                    <Route path="/home/map" element={<Maps />} />
                                    <Route path="/home/alarms" element={
                                        <Alarms 
                                            handlePopupInfo={handlePopupInfo} 
                                            setShowPopupInfo={setShowPopupInfo} 
                                            showPopupInfo={showPopupInfo} 
                                            handlePopupAlarm={handlePopupAlarm} 
                                            setShowPopupAlarm={setShowPopupAlarm} 
                                            showPopupAlarm={showPopupAlarm} 
                                        />
                                    } 
                                    />
                                    <Route 
                                        path="/home/settings" 
                                        element={
                                            <Settings 
                                                changeTheme={changeTheme}
                                                batteryPercentage={(val:any)=>updateBatteryPercentage(val)} 
                                                valueRefreshAPI={(val:any)=>updateValueRefreshAPI(val)}                                             
                                                regularTag={(val:any)=>updateRegularTag(val)}                                             
                                                statusDevice={(val:any)=>updateStatusDevice(val)} 
                                            />
                                        } 
                                    />
                                    <Route path="/home/configuration/synchro" element={<Synchro />} />
                                    <Route path="/home/configuration/maps" element={<ConfigMaps />} />                                    
                                    <Route path="/home/configuration/beacons" element={<ConfigBeacons />} />                       
                                    <Route path="/home/configuration/devices/devices-enable" element={<ConfigDevicesEnable />} />
                                    <Route path="/home/configuration/devices/devices-management" element={<ConfigDevicesManagement />} />
                                    <Route path="/home/configuration/devices/devices-binding" element={<ConfigDevicesBinding />} />
                                    <Route path="/home/configuration/rules/timeslot" element={<ConfigRulesTimeslot />} />
                                    <Route path="/home/configuration/rules/subscription" element={<ConfigRulesSubscription />} />
                                    <Route path="/home/configuration/rules/alarmActionHandlers" element={<ConfigRulesAlarmActionHandlers />} />
                                    <Route path="/home/configuration/rules/subscriptionAPI" element={<ConfigRulesSubscriptionAPI />} />
                                    {/*<Route path="/home/configuration/locator/client" element={<ConfigLocatorClient changeTheme={changeTheme}/>} />                                    */}
                                    <Route path="/home/configuration/locator/collector" element={<ConfigLocatorCollector />} />                                    
                                    <Route path="/home/configuration/locator/server" element={<ConfigLocatorServer />} />                                    
                                    <Route path="/home/configuration/locator/synchro" element={<ConfigLocatorSynchro />} />                                    
                                    <Route path="/home/configuration/privacy" element={<ConfigPrivacy />} />                                    
                                    <Route path="/home/configuration/registry/groups" element={<RegistryGroups />} />                                    
                                    <Route path="/home/configuration/registry/jobs" element={<RegistryJobs />} />                                  
                                    <Route path="/home/configuration/analysis/heatmap" element={<HeatMap />} />       
                                    <Route path="/home/configuration/maps/zones" element={<ConfigZones />} />       

                                    <Route path="/home/azure_map" element={<AzureMapComponent />} />                           
                                </Route>
                            </>                 
                        :
                            <>
                                <Route path="*" element={<LoginPage handleLogin={handleLogin} />} />
                            </>
                        }
                        </Routes>
                    </AppContext.Provider>
                </IntlProvider>
            </LocalizationProvider>
        </div>
    );
}

export default App;
function jwtDecode(token: string) {
    throw new Error('Function not implemented.');
}

